import { type FC } from "react";
import { useSearchParams } from "react-router-dom";
import HourglassBottom from "@mui/icons-material/HourglassBottom";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";
import { SignOutButton } from "../components/sign-out-button";

export const SessionExpiredPage: FC = () => {
  const [searchParams] = useSearchParams();

  return (
    <InfoPageLayout>
      <InfoPage
        title="Сессия завершена"
        message="Войдите снова, чтобы продолжить работу"
        illustration={<InfoPageIllustration icon={HourglassBottom} />}
        actions={
          <>
            <SignOutButton />
            <SignInButton returnUrl={searchParams.get("returnUrl")} />
          </>
        }
      />
    </InfoPageLayout>
  );
};
